export const MINIO_BUCKET_URL = 'https://documents.colendilabs.com/compi'
